import { Select } from "antd";
import xlsx from "json-as-xlsx";
import { isEmpty } from "lodash";
import CardDiv from "modules/common/card-div/CardDiv";
import PerformanceTable from "modules/performance_dashboard/PerformanceTable";
import usePerformanceStore from "modules/performance_dashboard/store";
import { useUserInfo } from "modules/user_management/store";
import { isDownloadDisabled } from "modules/utilities/utility";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

function PerformanceDashboard() {
  const { performanceData, performanceLoading, fetchPerformanceData } =
    usePerformanceStore();
  const { fetchUserData, userData } = useUserInfo();

  const [startDate, setStartDate] = useState(moment().startOf("days")._d);
  const [allUser, setAllUser] = useState({});
  const [agent, setAgent] = useState(null);

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    const allUserData = {};
    userData?.map((user) => {
      allUserData[user?.user?.id] = user?.user?.first_name;
    });
    setAllUser(allUserData);
  }, [performanceData, userData]);

  useEffect(() => {
    const objPayload = {
      startDate: moment(startDate).startOf('days').toISOString(),
      endDate: moment(startDate).endOf("days").toISOString(),
    };
    fetchPerformanceData(objPayload);
  }, [startDate]);

  const handleSelectAgent = (selectedValue) => {
    setAgent(selectedValue);
  };

  const handleClear = () => {
    setStartDate(moment().startOf("days")._d);
  };

  const handleDownload = async () => {
    const _data = Object.keys(performanceData)?.map((el) => {
      const rowData = performanceData[el];
      return {
        ...el,
        agentName: allUser[el] ? allUser[el] : "",
        totalAttempted: rowData?.total_attempted_call
          ? rowData?.total_attempted_call
          : "0",
        totalAnswered: rowData?.total_answered_call
          ? rowData?.total_answered_call
          : "0",
        totalUnAnswered: rowData?.total_unanswered_call
          ? rowData?.total_unanswered_call
          : "0",
        totalAttDuration: rowData?.attempt_duration
          ? (Number(rowData?.attempt_duration) / 60000).toFixed(2)
          : "0",
        avgAttemptDuration:
          (Number(rowData?.total_answered_call) > 0 &&
          Number(rowData?.attempt_duration) > 0
            ? (
                Number(rowData?.attempt_duration) /
                Number(rowData?.total_answered_call) /
                60000
              ).toFixed(2)
            : 0) || "0",
      };
    });

    const data = [
      {
        sheet: "Engagement Report",
        columns: [
          { label: "Agent Name", value: "agentName" || " " },
          { label: "Total Attempted Call", value: "totalAttempted" || " " },
          { label: "Total Answered Call", value: "totalAnswered" || " " },
          { label: "Total Unanswered Call", value: "totalUnAnswered" || " " },
          { label: "Total Talk Time", value: "totalAttDuration" || " " },
          { label: "Average Talk Time", value: "avgAttemptDuration" || " " },
        ],
        content: _data,
      },
    ];
    let settings = {
      fileName: `Agent Performance Data`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="fs-2">Performance Dashboard</div>
            <div className="d-flex gap-2 align-item-center">
              <Select
                allowClear
                onChange={handleSelectAgent}
                optionFilterProp="label"
                placeholder="Search an Agent"
                showSearch
                style={{ width: "20rem" }}
                className=" "
              >
                {!isEmpty(performanceData) &&
                  Object.keys(performanceData).map((agent) => {
                    const agentLabel = allUser[agent];

                    return (
                      <Option label={agentLabel} value={agentLabel} key={agent}>
                        <div>{agentLabel}</div>
                      </Option>
                    );
                  })}
              </Select>
              <div className="d-flex gap-2">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Select previous Date"
                />
                <button
                  className="btn btn-primary"
                  style={{ height: "2.26rem" }}
                  onClick={handleClear}
                >
                  Clear
                </button>
                <button
                  className="btn btn-primary"
                  style={{ height: "2.26rem" }}
                  onClick={handleDownload}
                  disabled={isDownloadDisabled}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        }
        component={
          <div>
            <PerformanceTable
              performanceData={performanceData}
              performanceLoading={performanceLoading}
              allUser={allUser}
              agent={agent}
            />
          </div>
        }
      />
    </div>
  );
}

export default PerformanceDashboard;
